import { render, staticRenderFns } from "./sport.vue?vue&type=template&id=6434384e&"
import script from "./sport.vue?vue&type=script&lang=js&"
export * from "./sport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports